namespace $.$$ {

	export class $shm_hitalama_map_book extends $.$shm_hitalama_map_book {
		
		widget_props_visible() {
			// return []
			return this.widget_for_settings()
				? [this.Widget_props()]
				: []
		}

		title() {
			return this.map().title()
		}

		@ $mol_action
		cut() {
			$shm_hitalama_profile.current()?.cut_map( this.map().link() )
		}

		pages(): readonly ( any )[] {
			const map = this.map()
			if( map.Version()?.val() !== undefined ) {
				$shm_hitalama_map_migration.migrate( map )
			}
			return super.pages()
		}

		widget_list_view(): readonly ( any )[] {
			return (this.editor_mode_enabled() || this.Head().widget_list_visible()) 
				? [this.Widgets()] : []
		}

		tool_modes_left() {
			return this.widget_list_view().length ? '18.25rem' : '0.25rem'
		}

		map_or_editor(): readonly ( any )[] {
			return (this.editor_mode_enabled())
				? [this.Editor()] : [this.Map_page()]
		}
		
		id( id: any ): string {
			return id
		}

		@ $mol_action
		map_cut() {
			$shm_hitalama_profile.current()?.cut_map( this.map().link() )
		}
		
		widget_for_editor() {
			const ref = this.$.$mol_state_arg.value( 'edit_widget' )! 
				?? this.Map_page().selected_links().at(0)?.toString() 
			
			if( !ref ) return null

			this.$.$mol_state_arg.value( 'edit_widget', ref )!

			return this.map().widget( ref )
		}

		@ $mol_mem
		widget_for_settings() {//overlay map pull it to, so it can be broken
			const sel_link = this.selected_links().at(0)?.toString()

			const ref = this.Head().widget_props_visible()
				? sel_link
				: sel_link == this.$.$mol_state_arg.value( 'widget_props' )
					? this.$.$mol_state_arg.value( 'widget_props' )
					: null

			if( !ref ) {
				if( this.$.$mol_state_arg.value( 'map' ) == this.map().link().str ) {
					this.$.$mol_state_arg.value( 'widget_props', null )
				}

				return null
			}

			if( !ref ) return null
			return this.map().widget( ref )
		}

	}
}
